'use strict';

var tslib_es6 = require('./tslib.es6-130a177d.js');
var styled = require('styled-components');

var breakpoints = {
    breakpointIphone5: '320px',
    breakpointMobileSmall: '375px',
    breakpointTablet: '767px',
    breakpointMobile: '959px',
    breakpointDesktop: '960px',
    breakpointMidDesktop: '1024px',
    breakpointSemiWideScreens: '1224px',
    breakpointMidWideScreens: '1280px',
    breakpointWideScreens: '1440px',
    breakpointExtraWideScreens: '1536px',
    breakpointUltraWideScreens: '1790px',
};
var getBreakPointValue = function (breakpoint) { return parseInt(breakpoints[breakpoint].replace('px', ''), 10); };
var above = function (screenType) { return "min-width: " + breakpoints[screenType]; };
var under = function (screenType) { return "max-width: " + (getBreakPointValue(screenType) - 1) + "px"; };
var generateAboveMediaQueries = function (screenType) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    @media all and (", ") {\n        ", "\n    }\n"], ["\n    @media all and (", ") {\n        ", "\n    }\n"])), above(screenType), styled.css.apply(void 0, args));
}; };
var generateUnderMediaQueries = function (screenType) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    @media all and (", ") {\n        ", "\n    }\n"], ["\n    @media all and (", ") {\n        ", "\n    }\n"])), under(screenType), styled.css.apply(void 0, args));
}; };
var forIPhone5 = generateAboveMediaQueries('breakpointIphone5');
var forMobileSmall = generateAboveMediaQueries('breakpointMobileSmall');
var forMobile = generateAboveMediaQueries('breakpointMobile');
var forTablet = generateAboveMediaQueries('breakpointTablet');
var forDesktop = generateAboveMediaQueries('breakpointDesktop');
var forMidDesktop = generateAboveMediaQueries('breakpointMidDesktop');
var forSemiWideScreens = generateAboveMediaQueries('breakpointSemiWideScreens');
var forMidWideScreens = generateAboveMediaQueries('breakpointMidWideScreens');
var forWideScreens = generateAboveMediaQueries('breakpointWideScreens');
var forExtraWideScreens = generateAboveMediaQueries('breakpointExtraWideScreens');
var forUltraWideScreens = generateAboveMediaQueries('breakpointUltraWideScreens');
var underIPhone5 = generateUnderMediaQueries('breakpointIphone5');
var underMobileSmall = generateUnderMediaQueries('breakpointMobileSmall');
var underMobile = generateUnderMediaQueries('breakpointMobile');
var underTablet = generateUnderMediaQueries('breakpointTablet');
var underDesktop = generateUnderMediaQueries('breakpointDesktop');
var underMidDesktop = generateUnderMediaQueries('breakpointMidDesktop');
var underSemiWideScreens = generateUnderMediaQueries('breakpointSemiWideScreens');
var underMidWideScreens = generateUnderMediaQueries('breakpointMidWideScreens');
var underWideScreens = generateUnderMediaQueries('breakpointWideScreens');
var underExtraWideScreens = generateUnderMediaQueries('breakpointExtraWideScreens');
var underUltraWideScreens = generateUnderMediaQueries('breakpointUltraWideScreens');
var getMediaStringValue = function (screenType, maxWidth, boundary) {
    if (boundary) {
        var numericBoundaryBreakPoint = Number(breakpoints[boundary].slice(0, -2));
        return "\n\t\t\t\t\t(min-width: " + breakpoints[screenType] + ") and (max-width: " + (numericBoundaryBreakPoint - 1) + "px)\n\t\t\t";
    }
    return maxWidth ? "(max-width: " + breakpoints[screenType] + ")" : "(min-width: " + breakpoints[screenType] + ")";
};
var getWindowMediaMatch = function (screenType) {
    if (typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.matchMedia)) {
        var minWidth = breakpoints[screenType];
        var mediaQuery = window.matchMedia("all and (min-width: " + minWidth + ")");
        return mediaQuery.matches;
    }
    return false;
};
var getWindowMediaMatchV2 = function (minScreenType, maxScreenType) {
    if (typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.matchMedia)) {
        var mediaQuery = window.matchMedia("all and (" + above(minScreenType) + ") " + (maxScreenType ? "and (" + above(maxScreenType) + ")" : ''));
        return mediaQuery.matches;
    }
    return false;
};
var isTablet = function () { return getWindowMediaMatch('breakpointTablet'); };
var isTabletV2 = function () { return getWindowMediaMatchV2('breakpointTablet', 'breakpointDesktop'); };
var isDesktop = function () { return getWindowMediaMatch('breakpointDesktop'); };
var isMobile = function () { return getWindowMediaMatch('breakpointMobile'); };
var isMobileV2 = function () { return getWindowMediaMatchV2('breakpointIphone5', 'breakpointMobile'); };
var isMidDesktop = function () { return getWindowMediaMatch('breakpointMidDesktop'); };
var isSemiWideScreen = function () { return getWindowMediaMatch('breakpointSemiWideScreens'); };
styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    max-width: ", ";\n    margin: auto;\n"], ["\n    max-width: ", ";\n    margin: auto;\n"])), breakpoints.breakpointWideScreens);
var breakPointToMediaQuery = function (screenType) {
    var forX = {
        breakpointIphone5: forIPhone5,
        breakpointTablet: forTablet,
        breakpointMobile: forMobile,
        breakpointDesktop: forDesktop,
        breakpointMidDesktop: forMidDesktop,
        breakpointSemiWideScreens: forSemiWideScreens,
        breakpointMidWideScreens: forMidWideScreens,
        breakpointWideScreens: forWideScreens,
    };
    return forX[screenType];
};
var iphoneXMediaQuery = "\n    @media only screen \n    and (min-device-width : 375px) \n    and (max-device-width : 812px)\n    and (-webkit-device-pixel-ratio : 3)\n";
var templateObject_1, templateObject_2, templateObject_3;

exports.breakPointToMediaQuery = breakPointToMediaQuery;
exports.breakpoints = breakpoints;
exports.forDesktop = forDesktop;
exports.forExtraWideScreens = forExtraWideScreens;
exports.forIPhone5 = forIPhone5;
exports.forMidDesktop = forMidDesktop;
exports.forMidWideScreens = forMidWideScreens;
exports.forMobile = forMobile;
exports.forMobileSmall = forMobileSmall;
exports.forSemiWideScreens = forSemiWideScreens;
exports.forTablet = forTablet;
exports.forUltraWideScreens = forUltraWideScreens;
exports.forWideScreens = forWideScreens;
exports.getBreakPointValue = getBreakPointValue;
exports.getMediaStringValue = getMediaStringValue;
exports.iphoneXMediaQuery = iphoneXMediaQuery;
exports.isDesktop = isDesktop;
exports.isMidDesktop = isMidDesktop;
exports.isMobile = isMobile;
exports.isMobileV2 = isMobileV2;
exports.isSemiWideScreen = isSemiWideScreen;
exports.isTablet = isTablet;
exports.isTabletV2 = isTabletV2;
exports.underDesktop = underDesktop;
exports.underExtraWideScreens = underExtraWideScreens;
exports.underIPhone5 = underIPhone5;
exports.underMidDesktop = underMidDesktop;
exports.underMidWideScreens = underMidWideScreens;
exports.underMobile = underMobile;
exports.underMobileSmall = underMobileSmall;
exports.underSemiWideScreens = underSemiWideScreens;
exports.underTablet = underTablet;
exports.underUltraWideScreens = underUltraWideScreens;
exports.underWideScreens = underWideScreens;
//# sourceMappingURL=viewport.utils-0c2b4e2b.js.map
